import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import Roblox from 'Roblox';
import App from './App';
import { rootElementId } from './app.config';
import '../../../css/verificationUpsellModal/verificationUpsellModal.scss';
import {
  handleUserEmailUpsellAtLogout,
  handleUserEmailUpsellAtBuyRobux,
  handleUserEmailUpsellAtPremiumSubscription
} from './services/userEmailServices';

// Expose service to external apps
Roblox.EmailVerificationService = {
  handleUserEmailUpsellAtLogout,
  handleUserEmailUpsellAtBuyRobux,
  handleUserEmailUpsellAtPremiumSubscription
};

ready(() => {
  if (document.getElementById(rootElementId)) {
    render(<App />, document.getElementById(rootElementId));
  }
});
